import moment from 'moment-timezone';
import { mostrarMoneda, idToTexto } from '@/utils/utils.js';

var groupBy = function (xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

export default {
  getPedidosRealizandoTpv(state) {
    //para boss negocio, agrupa todos los listado de pedidos
    console.log(state.pedidosRealizandoTpv);
    return state.pedidosRealizandoTpv;
  },
  getProductosListadoBossNegocio(state, getters) {
    let res = [...state.pedidosArray, ...getters.getPedidosRealizandoTpv]
      .filter((p) => !p.eliminado)
      .map((pedido) => {
        return pedido.productos;
      })
      .flat();

    let res2 = Object.values(groupBy(res, 'id')).map((arrayProductos) => {
      let prdComun = arrayProductos[0];
      console.log(prdComun);
      return {
        id: prdComun.id,
        nombre: prdComun.nombre,
        cantidad: arrayProductos.reduce((a, b) => a + (b.cantidad || 0), 0),
        total: arrayProductos.reduce(
          (a, b) => a + (b.precioProductoTotal || 0),
          0
        ),
        totalMostrar: mostrarMoneda(
          arrayProductos.reduce((a, b) => a + (b.precioProductoTotal || 0), 0)
        ),
      };
    });
    console.log(res2);
    return res2;
  },
  getPedidosListadoBossNegocioTpv(state, getters) {
    return getters.getPedidosRealizandoTpv
      .map((p) => {
        let tz = !!p.copyRest.confGeneral.zonaHoraria
          ? p.copyRest.confGeneral.zonaHoraria
          : 'Europe/Madrid';
        let actualMoment = moment(state.horaActual);
        let fechaMoment = moment(p.fechaServidor.toDate()).tz(tz);
        var durantion = moment.duration(actualMoment.diff(fechaMoment));
        return {
          ...p,
          nombreModo: p.modoCopy ? p.modoCopy.nombre : p.modo,
          fechaMostrarContador: parseInt(durantion.asMinutes()),
          fechaMoment: fechaMoment,
          fechaMostrar: moment(p.fechaServidor.toDate()).tz(tz).format('HH:mm'),
          cantidadMostrar: mostrarMoneda(p.precioTotal),
          formaPago: idToTexto(p.forma_pago),
        };
      })
      .sort((a, b) => b.fechaMoment - a.fechaMoment);
  },
  getPedidosListadoBossNegocioOnline(state, getters) {
    return [...state.pedidosArray, ...getters.getPedidosRealizandoTpv]
      .filter((p) => p.estado == 'finalizado') //el estadoo finalizado hace referencia a la web
      .map((p) => {
        let tz = !!p.copyRest.confGeneral.zonaHoraria
          ? p.copyRest.confGeneral.zonaHoraria
          : 'Europe/Madrid';
        let actualMoment = moment(state.horaActual);
        let fechaMoment = moment(p.fechaServidor.toDate()).tz(tz);
        var durantion = moment.duration(actualMoment.diff(fechaMoment));
        return {
          ...p,
          nombreModo: p.modoCopy ? p.modoCopy.nombre : p.modo,
          fechaMostrarContador: parseInt(durantion.asMinutes()),
          fechaMoment: fechaMoment,
          fechaMostrar: moment(p.fechaServidor.toDate()).tz(tz).format('HH:mm'),
          cantidadMostrar: mostrarMoneda(p.precioTotal),
          formaPago: idToTexto(p.forma_pago),
        };
      })
      .sort((a, b) => b.fechaMoment - a.fechaMoment);
  },
  getPedidosListado(state, getters, rootState, rootGetters) {
    var res = [];
    var pedidosRecorrer;
    if (rootGetters['auth/role'] == 'boss_negocio') {
      pedidosRecorrer = [
        ...state.pedidosArray,
        ...getters.getPedidosRealizandoTpv,
      ];
    } else {
      pedidosRecorrer = state.pedidosArray;
    }
    pedidosRecorrer.forEach((pedR) => {
      //const aux = JSON.parse(JSON.stringify(pedR));
      const aux = pedR;
      let tlf =
        pedR.copyUser && pedR.copyUser.phoneNumber
          ? pedR.copyUser.phoneNumber
          : '-';
      aux.fecha = moment(aux.fechaServidor.toDate()).format('HH:mm');
      aux.restauranteMostrar = aux.multiple
        ? aux.copyDirectorio
          ? aux.copyDirectorio.nombre
          : 'Directorio sin nombre'
        : aux.copyRest.nombre === aux.copyNegocio.nombre
        ? aux.copyRest.nombre
        : (aux.copyNegocio ? aux.copyNegocio.nombre : '') +
          ' ' +
          (aux.copyRest ? aux.copyRest.nombre : '');
      aux.precioTotal = mostrarMoneda(aux.precioTotal);
      aux.formaPago = idToTexto(aux.forma_pago);
      aux.telefono = tlf;
      aux.contadorMensaje = pedR.historial
        ? pedR.historial.reduce(
            (n, h) => n + h.mensaje.includes('Mensaje desde la web'),
            0
          )
        : 0;
      // aux.dobleVerificacion = pedR.historial ? (pedR.historial.reduce((n, h) => n + (h.mensaje.includes('confirmado segunda verificación')), 0)) > 0 : false
      switch (pedR.printNodeEstado) {
        case 'enviadoImprimir':
          aux.colorPrinter = 'orange';
          break;
        case 'imprimido':
          aux.colorPrinter = 'green';
          break;
        default:
          aux.colorPrinter = 'red';
          break;
      }
      switch (
        pedR.estadoReparto //no-gestionado, creado, asignado, recogido, entregado, problema
      ) {
        case 'no-gestionado':
          aux.repartoColor = 'orange';
          aux.repartoTexto = 'Sin gestionarse';
          break;
        case 'creado':
          aux.repartoColor = 'yellow';
          aux.repartoTexto = 'Creado la petición de reparto';
          break;
        case 'asignado':
          aux.repartoColor = 'pink';
          aux.repartoTexto = 'Asignado a repartidor';
          break;
        case 'en-camino':
          aux.repartoColor = 'blue';
          aux.repartoTexto = 'En reparto';
          break;
        case 'entregado':
          aux.repartoColor = 'green';
          aux.repartoTexto = 'Entregado';
          break;
        case 'problema':
          aux.repartoColor = 'red';
          aux.repartoTexto = 'Problema en el reparto';
          break;
        default:
          aux.repartoColor = 'red';
          aux.repartoTexto = 'Sin más info';
          break;
      }
      if (aux.multiple) {
        let found = state.pedidosArray.find((p) => p.multiple == aux.id);
        if (Array.isArray(aux.hijos)) {
          aux.hijos.push(found);
        } else {
          aux.hijos = [];
        }
      }
      res.push(aux);
    });
    //acoplamos pedidos multiple
    return res.map((multi) => {
      if (multi.multipleHijos && multi.multipleHijos.length > 0) {
        return {
          ...multi,
          multipleHijosObj: multi.multipleHijos.map((hijo) => {
            let found = res.find((p) => p.id == hijo);
            return found ? found : {};
          }),
        };
      } else {
        return multi;
      }
    });
  },
  getPedidosRestauranteListado(state, getters, rootState) {
    const restaurantes = rootState.app.restauranteGest;
    const pedidosTodos = state.pedidosArray.map((e) => {
      return e.array;
    });
    return pedidosTodos.flat(2).filter((e) => {
      return restaurantes.includes(e.negocio + '-' + e.restaurante);
    });
  },
  numeroPedidos(state) {
    //Online
    return state.pedidosArray.filter((p) => !p.eliminado && !p.multiple).length;
  },
  pedidosTpvContabilizar(state, getters) {
    return getters.getPedidosRealizandoTpv.filter(
      (p) => !p.eliminado && !p.multiplePadre && p.estado == 'tpv-realizando'
    );
  },
  pedidosOnlineContabilizar(state, getters) {
    return [
      ...state.pedidosArray.filter((p) => !p.eliminado && !p.multiplePadre),
      ...getters.getPedidosRealizandoTpv.filter(
        (p) => !p.eliminado && !p.multiplePadre && p.estado == 'finalizado'
      ),
    ];
  },
  numeroPedidosTpv(state, getters) {
    return getters.pedidosTpvContabilizar.length;
  },
  numeroPedidosTotal(state, getters) {
    return (
      getters.pedidosOnlineContabilizar.length + getters.numeroPedidosTpv
    ).toString();
  },
  totalPedidosOnline(state, getters) {
    return getters.pedidosOnlineContabilizar.reduce(
      (acc, val) => acc + parseFloat(val.precioTotal),
      0
    );
  },
  totalPedidosTpv(state, getters) {
    return getters.pedidosTpvContabilizar.reduce(
      (acc, val) => acc + parseFloat(val.precioTotal),
      0
    );
  },
  pedidosTotal(state, getters) {
    return getters.totalPedidosOnline + getters.totalPedidosTpv;
  },
  numeroPedidosRestaurante(state, getters) {
    return getters.getPedidosRestauranteListado
      .filter((p) => !p.eliminado)
      .length.toString();
  },

  numCantidad(state, getters) {
    return getters.getPedidosRestauranteListado
      .filter((p) => !p.eliminado)
      .length.toString();
  },
};
